/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input } from '@angular/core';
import { Subscription, forkJoin, Observable } from 'rxjs';
import { Validators, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import { AppService } from '../app.service';
import { IceNavService, menuItem } from '../../../projects/icemedx-lib/src/components/ice-nav/ice-nav.service';
import { LoginService } from '../../../projects/icemedx-lib/src/login/login.service';
import { Iceutility } from 'projects/icemedx-lib/src/services/iceutility';
import { IceTypes } from '../../../projects/icemedx-lib/src/models/icetypes';
import { MessageService } from '../../../projects/icemedx-lib/src/services/message/message.service';
import { DomainService } from '../../../projects/icemedx-lib/src/services/domain/domain.service';
import { OrderService } from 'projects/icemedx-lib/src/services/orders/order.service';
import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,
  SECTION_CONTROL_ALIGNMENT,
  iceColumnDefinition,
  IcedashboardiconSettings
} from 'projects/icemedx-lib/src/components/models/icesettings';

import { message } from '../../../projects/icemedx-lib/src/models/messages/message';
import { user } from '../../../projects/icemedx-lib/src/models/common/user';
import { messagereference } from '../../../projects/icemedx-lib/src/models/messages/messagereference';
import { LazyLoadManager } from '../../../projects/icemedx-lib/src/components/models/lazyload.manager';
import { managementguideline } from '../../../projects/icemedx-lib/src/models/ehr/subs/managementguideline';
import { patientindex } from '../../../projects/icemedx-lib/src/models/domain/patientindex';
import { provider_index } from '../../../projects/icemedx-lib/src/models/domain/provider_index';
import { IcelabelComponent } from 'projects/icemedx-lib/src/components/icelabel/icelabel.component';
import { IcepanelComponent } from 'projects/icemedx-lib/src/components/icepanel/icepanel.component';
import { IcepanelContainerComponent } from 'projects/icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { externaldata } from 'projects/icemedx-lib/src/models/ehr/externaldata';
import { subscriberindex } from '../../../projects/icemedx-lib/src/models/domain/subscriberindex';
import { payer_index } from '../../../projects/icemedx-lib/src/models/domain/payer_index';
import { pharmacyindex } from '../../../projects/icemedx-lib/src/models/domain/pharmacyindex';

const PostName: string = "PostName";
const From: string = "From";
const MessageBody: string = "MessageBody";
const ShareWithPrivate: string = "ShareWithPrivate";
const ShareWithPrivatePublic: string = "ShareWithPrivatePublic";
const CancelShare: string = "CancelShare";
const Dislike: string = "Dislike";
const Like: string = "Like";
const TimePosted: string = "TimePosted";
const Edit: string = "Edit";
const Delete: string = "Delete";
const Panel: string = "Panel";
const ProfilePicUrl: string = "ProfilePicUrl";
const TimeElapsed: string = "TimeElapsed";
const OriginalDate: string = "OriginalDate";
const FromUserId: string = "FromUserId";
const ReadMoreLinkEnabled: string = "ReadMoreLinkEnabled";
const ReadLessLinkEnabled: string = "ReadLessLinkEnabled";
const OriginalMessage: string = "OriginalMessage";
const Blog: string = "Blog";
const MessageDetail: string = "MessageDetail";

const EditBody: string = "EditBody";
const SubmitEdit: string = "SubmitEdit";
const CancelEdit: string = "CancelEdit";

const NewPostBody: string = "NewPostBody";
const NewPostTitle: string = "NewPostTitle";

const NewCommentBody: string = "NewCommentBody";
const SubmitComment: string = "SubmitComment";
const CancelComment: string = "CancelComment";

const CommentFrom: string = "CommentFrom";
const CommentBody: string = "CommentBody";
const CommentKey: string = "CommentKey";
const CommentName: string = "CommentName";

const EditCommentBody: string = "EditCommentBody";
const SubmitEditComment: string = "SubmitEditComment";
const CancelEditComment: string = "CancelEditComment";

const approvalDislike: string = "dislike";
const approvalLike: string = "like";
const maxMessageLength: number = 350;

const PostCountry: string = "PostCountry";
const PostSubject: string = "PostSubject";
const MessageImage: string = "MessageImage";

const DefaultPostingImage: string = "./assets/default_blog_image.png";
const FileUploadClicked: string = "FileUploadClicked";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [AppService, IceNavService, IcepanelComponent, IcepanelContainerComponent]
})
export class DashboardComponent implements OnInit {
  iconSettings: IcedashboardiconSettings = new IcedashboardiconSettings();
  thisYear = Iceutility.getYear();
  profilePicUrl: string = '';
  memberName: string = '';
  membersToMap: any = {};
  lastScrollPosition: number = 0;
  profileUrl: string = "";

  private actionItems: message[] = [];
  private actionItemMax: number = 10;
  private actionItemCount: number = 0;
  private newPostSubject: string = "";
  private newPostCountry: string = "";
  private newPostMessageKey: string = "";
  private newPostAttachments: externaldata[] = [];
  private newPostAttachmentFiles: any = {};
  private showLess: boolean = false;
  private itemsToShow: number = this.actionItemMax;
  private postingSettings: IcepanelcontainerRowSettings[] = [];

  ctrl: IcecontrolSettings = new IcecontrolSettings("icegraffiti", { width: "500", height: "200", showControlButtons: true, value: "", pagesettings: { width: "500", height: "200", linewidth: "1", visible: true } }, null, null, "graffiti", "")
    .createFormControl(0, []);

  tCtrl: IcecontrolSettings = new IcecontrolSettings("icetab", { width: "501", height: "200", tabs: [{ label: "Page 1", content: this.ctrl }] }, null, null, "tabs", "")
    .createFormControl(0, []);

  @Input() onCountryChange: Function = (event) => {
    this.newPostCountry = event.value;
  }

  @Input() onSubjectChange: Function = (event) => {
    this.newPostSubject = event.target.value;
  };

  private linkEditCountryCtrl = new IcecontrolSettings("icelabel", {
    linkMode: "labelselect", value: "Select country", width: "100px", menuItems: [
      { name: "Global", value: "" }, { name: "United States", value: "USA" }, { name: "Nigeria", value: "NGA" }], suppressParentEvent: true
  }, null, {
      change: this.onCountryChange
    }, PostCountry)
    .setControlName(PostCountry)
    .createFormControl('', []);
  private linkEditSubjectCtrl = new IcecontrolSettings("icelabel", { linkMode: "labeledit", value: "Enter subject", width: "100px", suppressParentEvent: true }, null, {
    change: this.onSubjectChange
  }, PostSubject)
    .setControlName(PostSubject)
    .createFormControl('', []);
  private newPostTitleCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%", hasFullWidthContainer: true }, null, null, NewPostTitle, "Title of Posting");
  private newPostMessageCtrl: IcecontrolSettings = new IcecontrolSettings("icetextarea", { width: "100%", hasFullWidthContainer: true }, null, null, NewPostBody, "Post a new message to your networks");
  private newSharePrivate: IcecontrolSettings = new IcecontrolSettings("icesubmitbutton", { class: "fas fa-paper-plane", width: "50px", tooltip: "Share with Private Network" }, null, null, ShareWithPrivate);
  private newPostPanel: IcepanelSettings = this.newPost();

  private newCommentMessageCtrl: IcecontrolSettings = new IcecontrolSettings("icetextarea", { width: "100%", hasFullWidthContainer: true }, null, null, NewCommentBody, "Add a new comment to this post.");
  private newCommentSubmit: IcecontrolSettings = new IcecontrolSettings("icesubmitbutton", { class: "fas fa-paper-plane", width: "50px", tooltip: "Comment on Post" }, null, null, SubmitComment);
  private newCommentPanel: IcepanelSettings = null;

  private editMessageCtrl: IcecontrolSettings = new IcecontrolSettings("icetextarea", { width: "100%", hasFullWidthContainer: true }, null, null, EditBody, "Enter new comments.");
  private editSubmit: IcecontrolSettings = new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px", tooltip: "Save Edit to Post" }, null, null, SubmitEdit);
  private editPanel: IcepanelSettings = null;

  private editCommentMessageCtrl: IcecontrolSettings = new IcecontrolSettings("icetextarea", { width: "100%", hasFullWidthContainer: true }, null, null, EditCommentBody, "Enter new comments.");
  private editCommentSubmit: IcecontrolSettings = new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px", tooltip: "Save Edit to Post" }, null, null, SubmitEditComment);
  private editCommentPanel: IcepanelSettings = null;
  private menuItems = [];

  public menuItemsCtrl = new IcecontrolSettings("icesplitbutton", { text: "Share with Private Network", class: [], glyphClass: "fas fa-paper-plane", menuItems: this.menuItems }, null, null);
  public postMenuItemsCtrl = new IcecontrolSettings("icesplitbutton", { text: "Share", class: [], glyphClass: null, menuItems: this.menuItems }, null, null);
  public myNetworkActivityTime: string;

  lazyLoadMgr: LazyLoadManager = null;
  allMessageRefs: messagereference[] = null;

  private unreadMessagesReadySub: Subscription = this.navSvc.onUnReadMessageReady().subscribe(
    msgs => {
      this.iconSettings.messageCount = this.navSvc.getUnreadMessageCount();
    },
    error => {
    });

  constructor(private appSvc: AppService,
    private router: Router,
    private loginSvc: LoginService,
    private navSvc: IceNavService,
    private messageService: MessageService,
    private domainService: DomainService,
    private ordSvc: OrderService) {
    this.appSvc.closePatient();
    this.appSvc.closeSubscriber();
    let actType: IceTypes.ACCOUNT_TYPE = this.appSvc.getCurrentAccountType();
    if (actType == IceTypes.ACCOUNT_TYPE.actPatient)
      this.appSvc.closeAccount();

    let userInfo = this.loginSvc.GetSessionUserInfo();
    this.memberName = userInfo.Name;
    this.domainService.mapMembers(userInfo.Username).subscribe(
      data => {
        if (data && data.length > 0 && data[0] != null) {
          this.domainService.loadMemberPhoto(userInfo.Username, data[0]["external_data_key"], this, this.onLoadProfilePicture);
        }
      },
      error => {
        console.log(JSON.stringify(this.messageService.getLastErrors()));
      });

    this.appSvc.setShowPrivateNetworkToolbar(true);
    this.appSvc.defaultMenus();
    this.iconSettings.messageRoute = this.navSvc.buildRoute("messages/inbox", false);
    this.iconSettings.ordersRoute = this.navSvc.buildRoute("EHR/orders", true);
    this.iconSettings.tasksRoute = this.navSvc.buildRoute("ToDoList", true);
    this.iconSettings.alertsRoute = this.navSvc.buildRoute("Alerts", true);
    this.appSvc.addBreadcrumb(actType == null || actType == IceTypes.ACCOUNT_TYPE.actNone ? "My Dashboard" : "Dashboard", {}, true, "");

    let domain = appSvc.getCurrentAccount();
    if (domain != null && domain.length > 0) {
      let useAPI = actType == IceTypes.ACCOUNT_TYPE.actProvider || actType == IceTypes.ACCOUNT_TYPE.actFacility ? "providers" : "pharmacies";
      ordSvc.getOrders(useAPI, domain, "", "", "", "", 0, 250, "", true).subscribe(
        data => {
          if (data != null) {
            this.iconSettings.ordersCount = data.length;
          }
        },
        error => {
          console.log(error);
        });
    }

    this.lastScrollPosition = window.scrollY;
    this.messageService.getMessages(IceTypes.MessageboxTypes.mboxPOSTS).subscribe(data => {
      this.allMessageRefs = [];
      if (data != null) {
        data = data.filter((test, index, array) =>
          index === array.findIndex((findTest) =>
            findTest.message_key === test.message_key
          )
        );
        for (let index = 0; index < data.length; index++) {
          this.allMessageRefs.push(data[index]);
        }
      }

      let minimumPerPage: number = 50;
      if (this.allMessageRefs.length > minimumPerPage) {
        window.addEventListener('scroll', (event) => {
          if (window.scrollY > this.lastScrollPosition && this.lastScrollPosition > 0)
            this.onBoardLazyLoad(event);

          this.lastScrollPosition = Math.max(window.scrollY, this.lastScrollPosition);
        });
      }

      this.lazyLoadMgr = new LazyLoadManager(data, minimumPerPage);
      this.lazyLoadMgr.processData(true).subscribe(
        lazyLoadData => {
          if (lazyLoadData == null) return;
          this.processMessages(lazyLoadData);
          this.lastScrollPosition = Math.max(window.scrollY, this.lastScrollPosition);
        },
        lazyLoadError => {
          console.log(lazyLoadError);
        });

    }, error => {
      this.lazyLoadMgr = new LazyLoadManager([], 10);
      console.log(JSON.stringify(this.messageService.getLastErrors()));
    });
  }

  processMessages(loadData: any): void {
    if (loadData == null) return;
    let msgrefs: messagereference[] = <messagereference[]>loadData;
    for (let index = 0; index < msgrefs.length; index++) {
      if (msgrefs[index] == null) continue;

      let tempmemid = msgrefs[index].from.toLowerCase();
      let mappedMember: user = <user>DomainService.mappedMembers[tempmemid];
      if (mappedMember == null) {
        if (this.membersToMap[tempmemid] == null)
          this.membersToMap[tempmemid] = [];

        this.membersToMap[tempmemid].push(msgrefs[index]);
      }

      if (msgrefs[index].parent_message_key.length > 0) {
        continue;
      }

      this.messageService.getMessage(msgrefs[index].message_key).subscribe(
        data => {
          if (data && data.length > 0 && data[0] != null) {
            let msg: message = data[0];
            if (msg == null) return;

            let appointmentInvite = false;
            if (msg.trans_type == IceTypes.TRANSTYPE.itInvite &&
              msg.GLRULES.length > 0 && msg.GLRULES[0].src_type == IceTypes.SourceType.srcTypeOfService) {
              appointmentInvite = true;
            }

            if (msg.trans_type == IceTypes.TRANSTYPE.itAlarm) {
              this.actionItems.push(msg);
              this.actionItemCount++;
              return;
            }
            else if ((!appointmentInvite
              && msg.trans_type == IceTypes.TRANSTYPE.itInvite
              && Iceutility.toLong(msg.message_status) != IceTypes.trans_status.isAccepted)
              || (appointmentInvite
                && Iceutility.toLong(msgrefs[index].message_status) != IceTypes.trans_status.isAccepted
                && Iceutility.toLong(msgrefs[index].message_status) != IceTypes.trans_status.isRejected)) {
              this.actionItems.push(msg);
              this.actionItemCount++;
              return;
            }
            else if (msg.trans_type == IceTypes.TRANSTYPE.itInvite) {
              // Since the above message type conditions are false then for
              // all other invite message let's not include them here.
              return;
            }

            let readMoreLinkEnabled = msg.message_body.length > maxMessageLength;
            msg["_fromUserId"] = msg.from;
            msg["_originalMessage"] = msg.message_body;
            msg["_readMoreLinkEnabled"] = readMoreLinkEnabled;
            msg.message_body = msg.message_body.length > maxMessageLength ? msg.message_body.substr(0, maxMessageLength) : msg.message_body;
            msg["_profilePicUrl"] = "./assets/default profile pic.png";
            this.loadPost(msg, msgrefs[index].message_status);

            let fromUser = <user>DomainService.mappedMembers[msg.from.toLowerCase()];
            if (fromUser != null && !Iceutility.isStringUndefinedNullOrEmpty(fromUser.external_data_key)) {
              this.loadMemberPhoto(msg, fromUser.external_data_key);
            }

            let attachments = msg.ATTACHMENTS;
            if (attachments != null && attachments.length > 0) {
              this.loadAttachments(msg);
            }
          }
        },
        error => {
          console.log(JSON.stringify(this.messageService.getLastErrors()));
        });
    }

    // Do Member mapping here
    setTimeout(() => {
      let dashComp = <DashboardComponent>this;
      let mems = Object.keys(this.membersToMap);
      if (mems.length > 0) {
        let memList = mems.join(",");
        this.domainService.mapMembers(memList).subscribe(
          data => {
            if (data == null) return;
            for (let imem = 0; imem < data.length; imem++) {
              let mem = <user>data[imem];

              let tempmemid = mem.login_user_name.toLowerCase();
              let msgAry = this.membersToMap[tempmemid];
              if (msgAry == null) continue;

              let fromName = mem.getdisplayname();

              for (let imsg = 0; imsg < msgAry.length; imsg++) {
                let msg = msgAry[imsg];
                if (msg == null) continue;
                msg["_displayName"] = fromName;
              }

              if (msgAry.length > 0 && !Iceutility.isStringUndefinedNullOrEmpty(mem.external_data_key)) {
                this.loadMemberPhoto(msgAry[0], mem.external_data_key);
              }
            }
            this.membersToMap = {}; // reset temp
          },
          error => {
            console.log(JSON.stringify(this.messageService.getLastErrors()));
          });
      }
    }, 500);
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
    this.getMenuItems();
    this.profileUrl = this.domainService.getUserProfileUrl();
  }

  ngOnDestroy() {
    this.unreadMessagesReadySub.unsubscribe();
  }

  //////////////////////////////
  // Board Creation function
  boardPost(msg: message, status: IceTypes.trans_status, overrideServerTimeConversion: boolean = false): IcepanelcontainerRowSettings {
    if (msg == null) return null;
    let post: IcepanelcontainerRowSettings = null;
    try {

      let messageDate = overrideServerTimeConversion ? Iceutility.getDateTextEx(msg.message_date) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(msg.message_date));
      let originalDate = overrideServerTimeConversion ? msg.message_date : Iceutility.ConvertFromDotNetServerTime(msg.message_date);

      let controls: IcecontrolSettings[] = [
        new IcecontrolSettings("icehidden", { value: msg.message_key, width: "200px", class: { "col-sm": true }, hasFullWidthContainer: false }, null, null, PostName + msg.message_key),
        new IcecontrolSettings("icelabel", { value: msg["_displayName"] != null ? msg["_displayName"] : msg.from, width: "200px", class: { "col-sm": true }, hasFullWidthContainer: false }, null, null, From + msg.message_key),
        new IcecontrolSettings("icelabel", { value: messageDate /*change to time elapsed*/, width: "200px", class: { "col-sm": true }, hasFullWidthContainer: false }, null, null, TimePosted + msg.message_key),
        new IcecontrolSettings("icelabel", { value: status, width: "10px", class: { "col-sm": true }, hasFullWidthContainer: false }, null, null, Like + msg.message_key),
        new IcecontrolSettings("icelabel", { value: status, width: "10px", class: { "col-sm": true }, hasFullWidthContainer: false }, null, null, Dislike + msg.message_key),
        new IcecontrolSettings("icelabel", { value: this.getFormattedMessage(msg.message_body), width: "200px", class: { "col-sm": true }, hasFullWidthContainer: false }, null, null, MessageBody + msg.message_key),
        new IcecontrolSettings("icehidden", { value: msg["_profilePicUrl"] }, null, null, ProfilePicUrl + msg.message_key),
        new IcecontrolSettings("icehidden", { value: this.getPostedTime(msg.message_date, overrideServerTimeConversion) }, null, null, TimeElapsed + msg.message_key),
        new IcecontrolSettings("icehidden", { value: originalDate }, null, null, OriginalDate + msg.message_key),
        new IcecontrolSettings("icehidden", { value: msg["_fromUserId"] }, null, null, FromUserId + msg.message_key),
        new IcecontrolSettings("icehidden", { value: msg["_originalMessage"] }, null, null, OriginalMessage + msg.message_key),
        new IcecontrolSettings("icehidden", { value: msg["_readMoreLinkEnabled"] }, null, null, ReadMoreLinkEnabled + msg.message_key),
        new IcecontrolSettings("icehidden", { value: msg["_readLessLinkEnabled"] }, null, null, ReadLessLinkEnabled + msg.message_key),
        new IcecontrolSettings("icehidden", { value: msg.blog }, null, null, Blog + msg.message_key),
        new IcecontrolSettings("icehidden", { value: msg }, null, null, MessageDetail + msg.message_key),
      ];

      let postSection: IcepanelsectionSettings = new IcepanelsectionSettings("PostingSection", { class: ["yalla"], styles: {} }, [], controls, null);

      let postingSections: IcepanelsectionSettings[] = [
        postSection
      ];

      let headerControls = [
        new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, Edit + msg.message_key),
        new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, Delete + msg.message_key)
      ];

      let panel: IcepanelSettings = new IcepanelSettings("BoardPosting", msg.message_key, msg.subject, Panel + msg.message_key, postingSections, headerControls);

      let panels: IcepanelSettings[] = [
        panel
      ];

      post = new IcepanelcontainerRowSettings(panels);

      let msgrefs: messagereference[] = this.allMessageRefs;
      setTimeout(() => {
        let commentRefs = msgrefs.filter(ref => ref.parent_message_key == msg.message_key);
        commentRefs.forEach((comment) => {
          this.messageService.getMessage(comment.message_key).subscribe(
            data => {
              if (data && data.length > 0 && data[0] != null) {
                let msgComment: message = data[0];
                if (msgComment == null) return;
                msgComment["_fromUserId"] = msgComment.from;
                let fromUser = <user>DomainService.mappedMembers[msgComment.from.toLowerCase()];
                msgComment["_displayName"] = fromUser != null ? fromUser.getdisplayname() : msgComment.from;
                this.boardPostComment(panel, msgComment);
              }
            },
            error => {
              console.log(JSON.stringify(this.messageService.getLastErrors()));
            });
        });
      }, 200);
    }
    catch (e) {
      console.log(e);
    }
    return post;
  }

  boardPostComment(panel: IcepanelSettings, msg: message): IcepanelsectionSettings {
    if (msg == null) return null;

    let commentSection: IcepanelsectionSettings = null;
    try {
      let commentctrls: IcecontrolSettings[] = [
        new IcecontrolSettings("icelabel", { value: msg.message_key, width: "10px", class: { "col-sm": true }, hasFullWidthContainer: false }, null, null, CommentKey + msg.message_key),
        new IcecontrolSettings("icelabel", { value: "", width: "200px", class: { "col-sm": true }, hasFullWidthContainer: false }, null, null, CommentName + msg.message_key),
        new IcecontrolSettings("icelabel", { value: msg["_displayName"] != null ? msg["_displayName"] : msg.from, width: "20px", class: { "col-sm": true }, hasFullWidthContainer: false }, null, null, CommentFrom + msg.message_key),
        new IcecontrolSettings("icelabel", { value: msg.message_body, width: "200px", class: { "col-sm": true }, hasFullWidthContainer: false }, null, null, CommentBody + msg.message_key),
        new IcecontrolSettings("icehidden", { value: msg["_fromUserId"], width: "", class: { "col-sm": true }, hasFullWidthContainer: false }, null, null, FromUserId + msg.message_key),
      ];

      commentSection = new IcepanelsectionSettings("CommentSection", { class: [""], styles: {} }, [], commentctrls, null);
      panel.sections.push(commentSection);

    }
    catch (e) {
      console.log(e);
    }
    return commentSection;
  }

  newPost(): IcepanelSettings {
    let newpost: IcepanelSettings = null;
    try {
      let controls: IcecontrolSettings[] = [];
      let headerControls: IcecontrolSettings[] = [];
      let userInfo = this.loginSvc.GetSessionUserInfo();

      this.newPostTitleCtrl.setControlName(NewPostTitle)
        .createFormControl("", [Validators.required]);
      this.newPostMessageCtrl.setControlName(NewPostBody)
        .createFormControl("", [Validators.required]);

      controls = [
        this.newPostTitleCtrl,
        this.newPostMessageCtrl,
      ];
      headerControls = [
        this.newSharePrivate,
        new IcecontrolSettings("icebutton", { class: "fas fa-save", width: "20px", tooltip: "Share with Private and Public Networks" }, null, null, ShareWithPrivatePublic),
        new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px", tooltip: "Cancel Share" }, null, null, CancelShare)
      ];

      let sections: IcepanelsectionSettings[] = [
        new IcepanelsectionSettings("NewPostSection", { class: [""], styles: { width: "100%" } }, null, controls, [])
      ];
      newpost = new IcepanelSettings("NewPostMessage", Iceutility.guid(false), "", "", sections, headerControls)
        .enableForm();
    }
    catch (e) {
      console.log(e);
    }
    return newpost;
  }

  getMessageDate(val: string): string {
    if (val == null || val.length == 0) return "";
    return Iceutility.isTextDateTime(val) ? Iceutility.getDateTextEx(val) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(val));
  }

  /////////////////////////////////////
  // Action Items
  getActionItemSubject(val: string): string {
    if (val == null || val.length == 0) return "";
    let parts = val.split(',');
    if (parts.length == 0) return "";
    if (parts.length == 1) return parts[0];
    return parts[0] + " (" + parts[parts.length - 1] + ")";
  }

  getActionItemStatus(msg: message): string {
    if (msg == null) return "";
    return MessageService.getStatus(Iceutility.toLong(msg.message_status));
  }

  getActionItemStatusDescription(msg: message): string {
    let defdesc = "needs your attention";
    if (msg == null || msg.GLRULES.length == 0) return defdesc;

    let gl = msg.GLRULES[0];
    if (gl == null || Iceutility.isStringUndefinedNullOrEmpty(gl.order_status_note))
      return Iceutility.toLong(gl.order_status_type) == IceTypes.orderentrystatus.oestatusApproved
        && Iceutility.toLong(msg.message_status) == IceTypes.trans_status.isApproved ? "Approved" : defdesc;

    return gl.order_status_note;
  }

  getActionItemGLs(msg: message): managementguideline[] {
    if (msg == null) return [];
    return msg.GLRULES;
  }

  getActionItemGLStatus(gl: managementguideline): string {
    if (gl == null) return "";
    if (Iceutility.toLong(gl.order_status_type) == IceTypes.orderentrystatus.oestatusRendered)
      return "Submitted";

    return OrderService.getStatus(Iceutility.toLong(gl.order_status_type));
  }

  getActionItemFrom(msg: message): string {
    if (msg == null) return "";
    let memid = msg.from.toLowerCase();
    let fromUser = <user>DomainService.mappedMembers[memid];
    if (fromUser == null) {
      return msg.from;
    }
    return fromUser.getdisplayname();
  }

  viewActionItemClick(event, msg: message): void {
    if (msg == null) return;
    this.router.navigate([this.navSvc.buildRoute("viewmessage/" + msg.message_key, false)]);
  }

  viewMoreActionItemsClick(event): void {
    this.router.navigate([this.navSvc.buildRoute("messages/action-items", false)]);
  }

  //////////////////////////////
  // Control decorators and getters
  getPostControl(panel: IcepanelSettings, id: string): IcecontrolSettings {
    let ctrl: IcecontrolSettings = null;
    let secs = panel.sections.filter(s => s.tag == "PostingSection")
    if (secs.length > 0) {
      let ctrls = secs[0].controls.filter(c => c.id == id + panel.panelKey);
      if (ctrls.length > 0) ctrl = ctrls[0];
    }
    return ctrl;
  }

  getPostControlValue(panel: IcepanelSettings, id: string): string {
    let ctrlValue = "";
    let secs = panel.sections.filter(s => s.tag == "PostingSection")
    if (secs.length > 0) {
      let ctrls = secs[0].controls.filter(c => c.id == id + panel.panelKey);
      if (ctrls.length > 0) ctrlValue = ctrls[0].properties != null ? ctrls[0].properties.value : "";
    }
    if (id == From) {
      // Just in case the member ID has been mapped but not displayed
      let memid = ctrlValue.toLowerCase();
      let fromUser = <user>DomainService.mappedMembers[memid];
      if (fromUser != null) {
        ctrlValue = fromUser.getdisplayname();
      }
    }
    else if (id == ProfilePicUrl) {
      // Use the member mapping to display the profile pic
      if (secs.length > 0) {
        let memid = "";
        let ctrls = secs[0].controls.filter(c => c.id == FromUserId + panel.panelKey);
        if (ctrls.length > 0) memid = ctrls[0].properties != null ? ctrls[0].properties.value : "";

        if (memid && memid.length > 0) {
          memid = memid.toLowerCase();
          let fromUser = <user>DomainService.mappedMembers[memid];
          if (fromUser != null && !Iceutility.isStringUndefinedNullOrEmpty(fromUser["_profilePicUrl"])) {
            ctrlValue = fromUser["_profilePicUrl"];
          }
        }
      }
    }
    else if (id == Blog) {
      let ctrls = secs[0].controls.filter(c => c.id == Blog + panel.panelKey);
      ctrlValue = ctrls[0].properties.value;
    }
    return ctrlValue;
  }

  getPostControlStyle(panel: IcepanelSettings, id: string): any {
    let ctrlStyle = {};
    let secs = panel.sections.filter(s => s.tag == "PostingSection")
    if (secs.length > 0) {
      let expectedStatus: IceTypes.trans_status = id == "Like" ? IceTypes.trans_status.isApproved : IceTypes.trans_status.isRejected;
      let ctrls = secs[0].controls.filter(c => c.id == id + panel.panelKey);
      if (ctrls.length > 0) {
        ctrlStyle = ctrls[0].properties != null && ctrls[0].properties.value == expectedStatus ? { color: '#df7000', cursor: 'pointer' } : { color: 'black', cursor: 'pointer' };
      }
    }
    return ctrlStyle;
  }

  isBlog(panel: IcepanelSettings): boolean {
    let ctrlValue = false;
    let secs = panel.sections.filter(s => s.tag == "PostingSection")
    if (secs.length > 0) {
      let ctrls = secs[0].controls.filter(c => c.id == Blog + panel.panelKey);
      ctrlValue = Iceutility.toBoolean(ctrls[0].properties.value);
    }
    return ctrlValue;
  }

  hasAttachments(panel: IcepanelSettings): boolean {
    let ret = false;
    let secs = panel.sections.filter(s => s.tag == "PostingSection")
    if (secs.length > 0) {
      let ctrls = secs[0].controls.filter(c => c.id == MessageDetail + panel.panelKey);
      if (ctrls.length > 0 && Iceutility.isdefined(ctrls[0].properties) && ctrls[0].properties.value != null) {
        let msg: message = <message>ctrls[0].properties.value;
        ret = msg != null && msg.ATTACHMENTS != null && msg.ATTACHMENTS.length > 0;
      }
    }
    return ret;
  }

  getAttachments(panel: IcepanelSettings): externaldata[] {
    let secs = panel.sections.filter(s => s.tag == "PostingSection")
    if (secs.length > 0) {
      let ctrls = secs[0].controls.filter(c => c.id == MessageDetail + panel.panelKey);
      if (ctrls.length > 0 && Iceutility.isdefined(ctrls[0].properties) && ctrls[0].properties.value != null) {
        let msg: message = <message>ctrls[0].properties.value;
        if (msg != null && msg.ATTACHMENTS != null && msg.ATTACHMENTS.length > 0)
          return msg.ATTACHMENTS;
      }
    }
    return [];
  }

  getAttachmentUrl(extData: externaldata): string {
    if (extData == null || false == Iceutility.isdefined(extData["_postImageUrl"])) return DefaultPostingImage;

    return extData["_postImageUrl"];
  }

  getNewAttachments(): externaldata[] {
    return this.newPostAttachments;
  }

  getNewAttachmentUrl(extData: externaldata): string {
    return DefaultPostingImage;
  }

  getNewAttachmentStatus(extData: externaldata): string {
    if (extData == null && this.newPostAttachmentFiles[FileUploadClicked] == true) return "Select file.";
    else if (extData == null && this.newPostAttachmentFiles[FileUploadClicked] == null) return "Loading.";

    if (extData != null && this.newPostAttachmentFiles[extData.original_path] != null) return extData.original_path + " Ready.";

    return "Copying " + (extData != null ? extData.original_path : "");
  }

  isMessageBodyLinkEnabled(panel: IcepanelSettings, isShowMoreLink): boolean {
    let ctrlValue = false;
    let secs = panel.sections.filter(s => s.tag == "PostingSection")
    if (secs.length > 0) {
      let ctrls = secs[0].controls.filter(c => c.id == (isShowMoreLink ? ReadMoreLinkEnabled : ReadLessLinkEnabled) + panel.panelKey);
      ctrlValue = ctrls.length > 0 && ctrls[0].properties != null ? ctrls[0].properties.value : false;
    }
    return ctrlValue;
  }

  showEditLink(panel): boolean {
    let from: string = this.getPostControlValue(panel, FromUserId);
    let userInfo = this.loginSvc.GetSessionUserInfo();
    return from.toLowerCase() == userInfo.Username.toLowerCase(); // later we should move this to CC
  }

  showEditCommentLink(panel: IcepanelSettings, section: IcepanelsectionSettings): boolean {
    let from: string = this.getCommentControlValue(panel, section, FromUserId);
    let userInfo = this.loginSvc.GetSessionUserInfo();
    return from && userInfo && userInfo.Username ? from.toLowerCase() == userInfo.Username.toLowerCase() : false; // later we should move this to CC
  }

  messageBodyLinkClick(panel: IcepanelSettings, isMoreLinkClicked: boolean) {
    let ctrlValue = "";
    let messageBody = "";
    let secs = panel.sections.filter(s => s.tag == "PostingSection")
    if (secs.length > 0) {
      let ctrls = secs[0].controls.filter(c => c.id == OriginalMessage + panel.panelKey);
      ctrlValue = ctrls.length > 0 && ctrls[0].properties != null ? ctrls[0].properties.value : "";

      let messageBodyCtrl = secs[0].controls.filter(c => c.id == MessageBody + panel.panelKey);
      if (messageBodyCtrl.length > 0 && messageBodyCtrl[0].properties != null) {
        messageBody = messageBodyCtrl[0].properties.value;
        messageBodyCtrl[0].properties.value = (isMoreLinkClicked ? ctrlValue : messageBody.substr(0, maxMessageLength));
      } else {
        messageBodyCtrl[0].properties.value = ctrlValue;
      }

      let moreLinkCtrl = secs[0].controls.filter(c => c.id == ReadMoreLinkEnabled + panel.panelKey);
      moreLinkCtrl[0].properties.value = moreLinkCtrl.length > 0 && moreLinkCtrl[0].properties != null ? (isMoreLinkClicked ? false : true) : true;

      let lessLinkCtrl = secs[0].controls.filter(c => c.id == ReadLessLinkEnabled + panel.panelKey);
      lessLinkCtrl[0].properties.value = lessLinkCtrl.length > 0 && lessLinkCtrl[0].properties != null ? (isMoreLinkClicked ? true : false) : false;
    }
  }

  getCommentControl(panel: IcepanelSettings, section: IcepanelsectionSettings, id: string): IcecontrolSettings {
    let ctrl: IcecontrolSettings = null;
    if (panel != null && section != null) {
      let ctrls = section.controls.filter(c => c.id.indexOf(id) >= 0);
      if (ctrls.length > 0) ctrl = ctrls[0];
    }
    return ctrl;
  }

  getCommentControlValue(panel: IcepanelSettings, section: IcepanelsectionSettings, id: string): string {
    if (panel == null) return "";
    if (section == null) return "";
    let ctrlValue = "";
    let ctrls = section.controls.filter(c => c.id.indexOf(id) >= 0);
    if (ctrls.length > 0) ctrlValue = ctrls[0].properties != null ? ctrls[0].properties.value : "";

    if (id == CommentFrom) {
      // Just in case the member ID has been mapped but not displayed
      let memid = ctrlValue.toLowerCase();
      let fromUser = <user>DomainService.mappedMembers[memid];
      if (fromUser != null) {
        ctrlValue = fromUser.getdisplayname();
      }
    }
    return ctrlValue;
  }

  getNewPostFormGroup(): FormGroup {
    if (this.newPostPanel == null)
      return null;

    let formGrp: FormGroup = this.newPostPanel.getForm();
    try {
      if (formGrp == null) // to prevent from getting form error we create an empty group place
        formGrp = new FormGroup({});
    }
    catch (e) {
      console.log(e);
    }

    return formGrp;
  }

  getNewCommentFormGroup(): FormGroup {
    if (this.newCommentPanel == null)
      return null;

    let formGrp: FormGroup = this.newCommentPanel.getForm();
    try {
      if (formGrp == null) // to prevent from getting form error we create an empty group place
        formGrp = new FormGroup({});
    }
    catch (e) {
      console.log(e);
    }

    return formGrp;
  }

  getEditFormGroup(): FormGroup {
    if (this.editPanel == null)
      return null;

    let formGrp: FormGroup = this.editPanel.getForm();
    try {
      if (formGrp == null) // to prevent from getting form error we create an empty group place
        formGrp = new FormGroup({});
    }
    catch (e) {
      console.log(e);
    }

    return formGrp;
  }

  getEditCommentFormGroup(): FormGroup {
    if (this.editCommentPanel == null)
      return null;

    let formGrp: FormGroup = this.editCommentPanel.getForm();
    try {
      if (formGrp == null) // to prevent from getting form error we create an empty group place
        formGrp = new FormGroup({});
    }
    catch (e) {
      console.log(e);
    }

    return formGrp;
  }

  hasProviderNetworks(): boolean {
    let usrInfo = this.loginSvc.GetSessionUserInfo();
    return this.loginSvc.hasDomainType(usrInfo, IceTypes.ACCOUNT_TYPE.actProvider);
  }

  hasPatientNetworks(): boolean {
    let usrInfo = this.loginSvc.GetSessionUserInfo();
    return this.loginSvc.hasDomainType(usrInfo, IceTypes.ACCOUNT_TYPE.actPatient);
  }

  onLoadProfilePicture(blob: File, dashboardComp: any) {
    try {
      const reader = new FileReader();
      reader.addEventListener('load', (event: any) => {
        if (<string>event["currentTarget"]["result"] != null)
          dashboardComp.profilePicUrl = <string>event["currentTarget"]["result"];
      });

      reader.readAsDataURL(blob);
    }
    catch (e) {
      console.log(e);
    }
  }

  ///////////////////////////
  // Profile Events
  onSelectProFilePicture(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      var fileToUpload = event.target.files[0];
      reader.onload = (event) => {
        let usrInfo = this.loginSvc.GetSessionUserInfo();
        this.domainService.insertMemberPhoto(usrInfo.Username, "", fileToUpload).subscribe(
          data => {
            this.domainService.loadMemberPhoto(usrInfo.Username, data[0]["external_data_key"], this, this.onLoadProfilePicture);
          },
          error => {
            console.log(error);
          });
      }
      reader.readAsDataURL(event.target.files[0]); // read file as data url
    }

  }

  onDeleteProFilePicture(event) {
    let usrInfo = this.loginSvc.GetSessionUserInfo();
    this.domainService.removeMemberPhoto(usrInfo.Username).subscribe(
      data => {
        this.profilePicUrl = "";
      },
      error => {
        console.log(error);
      });
  }

  ///////////////////////////
  // Board Events
  onBoardLazyLoad(event) {
    if (this.lazyLoadMgr == null) return;

    this.lazyLoadMgr.processData(false).subscribe(
      lazyLoadData => {
        this.processMessages(lazyLoadData);
      },
      lazyLoadError => {
        console.log(lazyLoadError);
      });
  }

  cancelEdit() {
    this.editPanel = null;
  }

  cancelComment() {
    this.newCommentPanel = null;
    this.newCommentMessageCtrl.getFormControl().reset();
  }

  cancelEditComment() {
    this.editCommentPanel = null;
  }

  editPostClick(event, panel: IcepanelSettings) {
    this.editPanel = null;
    try {
      let controls: IcecontrolSettings[] = [];
      let headerControls: IcecontrolSettings[] = [];
      let isReadMoreLinkVisible = this.getPostControlValue(panel, ReadMoreLinkEnabled);
      let isReadLessLinkVisible = this.getPostControlValue(panel, ReadLessLinkEnabled);

      let msgbody = (isReadMoreLinkVisible || isReadLessLinkVisible) ? this.getPostControlValue(panel, OriginalMessage) : this.getPostControlValue(panel, MessageBody);

      this.editMessageCtrl.setControlName(EditBody)
        .createFormControl(msgbody, [Validators.required]);

      // to do get value into edit

      controls = [
        this.editMessageCtrl,
      ];
      headerControls = [
        this.editSubmit,
        new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px", tooltip: "Cancel Edit" }, null, null, CancelEdit)
      ];

      let sections: IcepanelsectionSettings[] = [
        new IcepanelsectionSettings("EditPostSection", { class: [""], styles: { width: "100%" } }, null, controls, [])
      ];
      this.editPanel = new IcepanelSettings("EditPostMessage", panel.panelKey, "", "", sections, headerControls)
        .enableForm();
    }
    catch (e) {
      console.log(e);
    }
  }

  deletePostClick(event, panel: IcepanelSettings) {
    try {
      let msg: message = new message();
      let userInfo = this.loginSvc.GetSessionUserInfo();
      msg.from = userInfo.Username;
      msg.message_key = panel.panelKey;
      msg.to = this.getPostControlValue(panel, From);
      let relatedMsg = this.allMessageRefs.filter(r => r.message_key == panel.panelKey);
      if (relatedMsg.length > 0) {
        msg.to += "," + relatedMsg[0].to; // later we should move this to CC
        msg.account_type = relatedMsg[0].account_type;
        msg.trans_account = relatedMsg[0].trans_account;
      }

      msg.subject = panel.title;
      msg.offline_record_status = IceTypes.offlineRecStatus.offlineDelete;
      msg.trans_type = IceTypes.TRANSTYPE.itDashboardPost;

      this.messageService.deleteMessage(msg, IceTypes.MessageboxTypes.mboxPOSTS, this.navSvc).subscribe(data => {
        let posttoRemove = [];
        for (let ipost = 0; ipost < this.postingSettings.length; ipost++) {
          let post = this.postingSettings[ipost];
          if (post == null) continue;

          let todel = post.columns.filter(p => p.panelKey == panel.panelKey);
          if (todel.length > 0) {
            posttoRemove.push(ipost);
          }
        }

        for (let irem = 0; irem < posttoRemove.length; irem++) {
          this.postingSettings.splice(posttoRemove[irem], 1);
        }
      }, error => {
        console.log(error);
      });
    }
    catch (e) {
      console.log(e);
    }
  }

  editCommentClick(event, panel: IcepanelSettings, section: IcepanelsectionSettings) {
    this.editCommentPanel = null;
    try {
      let controls: IcecontrolSettings[] = [];
      let headerControls: IcecontrolSettings[] = [];

      let msgbody = this.getCommentControlValue(panel, section, CommentBody);

      this.editCommentMessageCtrl.setControlName(EditCommentBody)
        .createFormControl(msgbody, [Validators.required]);

      // to do get value into edit

      controls = [
        this.editCommentMessageCtrl,
      ];
      headerControls = [
        this.editCommentSubmit,
        new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px", tooltip: "Cancel Edit" }, null, null, CancelEditComment)
      ];

      let sections: IcepanelsectionSettings[] = [
        new IcepanelsectionSettings("EditCommentSection", { class: [""], styles: { width: "100%" } }, null, controls, [])
      ];
      this.editCommentPanel = new IcepanelSettings("EditCommentMessage", panel.panelKey, "", "", sections, headerControls)
        .enableForm();
    }
    catch (e) {
      console.log(e);
    }
  }

  addComment(event, panel: IcepanelSettings) {
    this.newCommentPanel = null;
    try {
      let controls: IcecontrolSettings[] = [];
      let headerControls: IcecontrolSettings[] = [];
      let userInfo = this.loginSvc.GetSessionUserInfo();

      this.newCommentMessageCtrl.setControlName(NewCommentBody)
        .createFormControl("", [Validators.required]);

      controls = [
        this.newCommentMessageCtrl,
      ];
      headerControls = [
        this.newCommentSubmit,
        new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px", tooltip: "Cancel Comment" }, null, null, CancelComment)
      ];

      let sections: IcepanelsectionSettings[] = [
        new IcepanelsectionSettings("NewPostSection", { class: [""], styles: { width: "100%" } }, null, controls, [])
      ];
      this.newCommentPanel = new IcepanelSettings("NewPostMessage", panel.panelKey, "", "", sections, headerControls)
        .enableForm();
    }
    catch (e) {
      console.log(e);
    }
  }

  onProivderNetworks(event) {
    location.href = this.navSvc.buildRoute("Providers", true);
  }

  onPatientNetworks(event) {
    this.router.navigate([this.navSvc.buildRoute("domain/" + IceTypes.ACCOUNT_TYPE.actPatient.toString(), false)]);
  }

  onMemberNetworks(event) {
    this.router.navigate([this.navSvc.buildRoute("members", false)]);
  }

  //////////////////////////////////
  // Toolbar Events
  onToolbarMenuItemOpen(event) {
    if (event.toolbar && event.toolbarItem) {
      let display = "";
      switch (Iceutility.toLong(event.toolbarItem.domaintype)) {
        case IceTypes.ACCOUNT_TYPE.actPatient: {
          let ptIdx: patientindex = event.toolbarItem.data;
          if (ptIdx) {
            display = "Patient: " + ptIdx.getdisplayname();
          }
          break;
        }
        case IceTypes.ACCOUNT_TYPE.actFacility:
        case IceTypes.ACCOUNT_TYPE.actProvider: {
          let proIdx: provider_index = event.toolbarItem.data;
          if (proIdx) {
            display = (event.toolbarItem.domaintype === IceTypes.ACCOUNT_TYPE.actFacility ? "Facility: " : "Provider: ") + proIdx.getdisplayname(event.toolbarItem.domaintype === IceTypes.ACCOUNT_TYPE.actFacility);
          }
          break;
        }
        case IceTypes.ACCOUNT_TYPE.actSubscriber: {
          let subIdx: subscriberindex = event.toolbarItem.data;
          if (subIdx) {
            display = "Subscriber: " + subIdx.getdisplayname();
          }
          break;
        }
        case IceTypes.ACCOUNT_TYPE.actPayer: {
          let pyrIdx: payer_index = event.toolbarItem.data;
          if (pyrIdx) {
            display = "Payer/Org.: " + pyrIdx.getdisplayname(true);
          }
          break;
        }
        case IceTypes.ACCOUNT_TYPE.actPharmacy: {
          let phrmIdx: pharmacyindex = event.toolbarItem.data;
          if (phrmIdx) {
            display = "Pharmacy: " + phrmIdx.getdisplayname(true);
          }
          break;
        }
      }

      if (event.toolbarItem.menuitem != null && event.toolbarItem.menuitem.length > 0
        && event.toolbar[event.toolbarItem.menuitem].menuItems != null) {
        let menuItems = event.toolbar[event.toolbarItem.menuitem].menuItems;
        let foundRoot = menuItems.filter(x => x.id == "root");
        if (foundRoot.length > 0) foundRoot[0].display = display;
      }
    }
  }
  onToolbarMenuItemClick(event) {
    if (event.toolbarItem && event.toolbarMenuItem) {
      switch (Iceutility.toLong(event.toolbarItem.domaintype)) {
        case IceTypes.ACCOUNT_TYPE.actPatient: {
          let ptIdx: patientindex = event.toolbarItem.data;
          if (ptIdx) {
            this.appSvc.openPatient(ptIdx.trans_account, true);
            this.router.navigate([this.navSvc.buildRoute(event.toolbarMenuItem.link, false)]);
          }
          break;
        }
        case IceTypes.ACCOUNT_TYPE.actSubscriber: {
          let subIdx: subscriberindex = event.toolbarItem.data;
          if (subIdx) {
            this.appSvc.openSubscriber(subIdx.subscriber_key, true);
            this.router.navigate([this.navSvc.buildRoute(event.toolbarMenuItem.link, false)]);
          }
          break;
        }
        case IceTypes.ACCOUNT_TYPE.actFacility:
        case IceTypes.ACCOUNT_TYPE.actProvider: {
          let proIdx: provider_index = event.toolbarItem.data;
          if (proIdx) {
            this.appSvc.closePatient();
            this.appSvc.openAccount(proIdx.trans_account, Iceutility.toLong(event.toolbarItem.domaintype));

            if (event.toolbarMenuItem.externallink && event.toolbarMenuItem.externallink.length > 0) {
              let tourl: string = this.navSvc.buildRoute(event.toolbarMenuItem.externallink, true);
              location.href = tourl;
            }
            else {
              this.router.navigate([this.navSvc.buildRoute(event.toolbarMenuItem.link, false)]);
            }
          }
          break;
        }
        case IceTypes.ACCOUNT_TYPE.actPayer: {
          let pyrIdx: payer_index = event.toolbarItem.data;
          if (pyrIdx) {
            this.appSvc.closePatient();
            this.appSvc.closeSubscriber();
            this.appSvc.openAccount(pyrIdx.trans_account, Iceutility.toLong(event.toolbarItem.domaintype));
            this.router.navigate([this.navSvc.buildRoute(event.toolbarMenuItem.link, false)]);
          }
          break;
        }
        case IceTypes.ACCOUNT_TYPE.actPharmacy: {
          let phrmIdx: pharmacyindex = event.toolbarItem.data;
          if (phrmIdx) {
            this.appSvc.closePatient();
            this.appSvc.closeSubscriber();
            this.appSvc.openAccount(phrmIdx.trans_account, Iceutility.toLong(event.toolbarItem.domaintype));
            this.router.navigate([this.navSvc.buildRoute(event.toolbarMenuItem.link, false)]);
          }
          break;
        }
      }

    }
  }

  //////////////////////////////////
  // Board Submissions
  changeCommentApproval(event: Event, panel: IcepanelSettings, approval: string) {
    let expectedStatus: IceTypes.trans_status = IceTypes.trans_status.isApproved;
    let secs = panel.sections.filter(s => s.tag == "PostingSection");

    if (approval == approvalDislike) {
      expectedStatus = IceTypes.trans_status.isRejected;
    }

    if (secs.length > 0) {
      let ctrls = secs[0].controls.filter(c => c.id === "Like" + panel.panelKey);
      if (ctrls.length > 0) {
        if (ctrls[0].properties.value == expectedStatus) {
          // reset the status
          expectedStatus = IceTypes.trans_status.isNone;
        }
      }
    }

    this.messageService.changeMessageApproval(panel.panelKey, expectedStatus, IceTypes.MessageboxTypes.mboxPOSTS, this.navSvc).subscribe(data => {
      let secs = panel.sections.filter(s => s.tag == "PostingSection")
      if (secs.length > 0) {
        let likeCtrls = secs[0].controls.filter(c => c.id.indexOf(Like) >= 0);
        let dislikeCtrls = secs[0].controls.filter(c => c.id.indexOf(Dislike) >= 0);
        if (likeCtrls.length > 0) {
          likeCtrls[0].properties.value = expectedStatus;
        }
        if (dislikeCtrls.length > 0) {
          dislikeCtrls[0].properties.value = expectedStatus;
        }
      }
    }, error => {
      console.log(error);
    });
  }

  submitEdit(event, panel: IcepanelSettings) {
    // To do add try catch
    let msg: message = new message();
    let userInfo = this.loginSvc.GetSessionUserInfo();
    msg.from = userInfo.Username;
    msg.message_key = panel.panelKey;
    msg.to = this.getPostControlValue(panel, From);
    let relatedMsg = this.allMessageRefs.filter(r => r.message_key == panel.panelKey);
    if (relatedMsg.length > 0) {
      msg.to += "," + relatedMsg[0].to; // later we should move this to CC
      msg.account_type = relatedMsg[0].account_type;
      msg.trans_account = relatedMsg[0].trans_account;
    }

    msg.subject = panel.title;
    msg.message_body = this.editMessageCtrl.getFormControl().value;
    msg.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
    msg.message_status = IceTypes.trans_status.isReadyToSend;
    msg.trans_type = IceTypes.TRANSTYPE.itDashboardPost;
    this.messageService.updateBoardMessage(msg, this.navSvc).subscribe(data => {
      this.editPanel = null;

      let secs = panel.sections.filter(s => s.tag == "PostingSection");
      let msgBody = msg.message_body.length > maxMessageLength ? msg.message_body.substr(0, maxMessageLength) : msg.message_body;

      if (secs.length > 0) {
        let ctrls = secs[0].controls.filter(c => c.id == OriginalMessage + panel.panelKey);
        ctrls[0].properties.value = msg.message_body;

        let msgBodyCtrl = secs[0].controls.filter(c => c.id == MessageBody + panel.panelKey);
        msgBodyCtrl[0].properties.value = msgBody;

        let moreLinkCtrl = secs[0].controls.filter(c => c.id == ReadMoreLinkEnabled + panel.panelKey);
        moreLinkCtrl[0].properties.value = msg.message_body.length > maxMessageLength;

        let lessLinkCtrl = secs[0].controls.filter(c => c.id == ReadLessLinkEnabled + panel.panelKey);
        lessLinkCtrl[0].properties.value = false;
      }

      let ctrl = this.getPostControl(panel, MessageBody);
      if (ctrl) ctrl.properties.value = msgBody;
    }, error => {
      console.log(error);
    });
  }

  submitEditComment(event, panel: IcepanelSettings, section: IcepanelsectionSettings) {
    // To do add try catch
    let msg: message = new message();
    let userInfo = this.loginSvc.GetSessionUserInfo();
    msg.from = userInfo.Username;
    msg.message_key = this.getCommentControlValue(panel, section, CommentKey);
    msg.to = this.getPostControlValue(panel, From);
    let relatedMsg = this.allMessageRefs.filter(r => r.message_key == panel.panelKey);
    if (relatedMsg.length > 0) {
      msg.to += "," + relatedMsg[0].to; // later we should move this to CC
      msg.account_type = relatedMsg[0].account_type;
      msg.trans_account = relatedMsg[0].trans_account;
    }

    msg.subject = panel.title;
    msg.message_body = this.editCommentMessageCtrl.getFormControl().value;
    msg.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
    msg.message_status = IceTypes.trans_status.isReadyToSend;
    msg.trans_type = IceTypes.TRANSTYPE.itDashboardPost;
    this.messageService.updateBoardMessage(msg, this.navSvc).subscribe(data => {
      this.editCommentPanel = null;
      this.editCommentMessageCtrl.getFormControl().reset();
      let ctrl = this.getCommentControl(panel, section, CommentBody);
      if (ctrl) ctrl.properties.value = msg.message_body;
    }, error => {
      console.log(error);
    });
  }

  submitComment(event, panel: IcepanelSettings) {
    // To do add try catch
    let msg: message = new message();
    let userInfo = this.loginSvc.GetSessionUserInfo();
    msg.from = userInfo.Username;
    msg.message_key = Iceutility.guid(false);
    msg.parent_message_key = panel.panelKey;
    msg.to = this.getPostControlValue(panel, From);
    let relatedMsg = this.allMessageRefs.filter(r => r.message_key == panel.panelKey);
    if (relatedMsg.length > 0) {
      msg.to += "," + relatedMsg[0].to; // later we should move this to CC
    }

    msg.subject = panel.title;
    msg.message_date = Iceutility.ConvertToUTC(Iceutility.GetLocalDate(), true);
    msg.message_body = this.newCommentMessageCtrl.getFormControl().value;
    msg.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    msg.trans_account = this.appSvc.getCurrentAccount();
    msg.account_type = this.appSvc.getCurrentAccountType();
    msg.message_status = IceTypes.trans_status.isReadyToSend;
    msg.trans_type = IceTypes.TRANSTYPE.itDashboardPost;

    this.messageService.sendMessage(msg, this.navSvc).subscribe(data => {
      this.newCommentPanel = null;
      this.newCommentMessageCtrl.getFormControl().reset();
      this.boardPostComment(panel, msg);
    }, error => {
      console.log(error);
    });
  }

  sharePrivateClick(event, panel) {
    if (event.headerCtrl && event.headerCtrl.id == CancelShare) {
      return;
    }

    if (event.headerCtrl instanceof IcepanelSettings) {
      let newMessagePanel: IcepanelSettings = event.headerCtrl;
      let newMessageForm: FormGroup = newMessagePanel.getForm();
      if (newMessageForm == null || false == newMessageForm.valid) {
        console.log("Invalid form");
        return;
      }
    }

    let userInfo = this.loginSvc.GetSessionUserInfo();

    let defaultTO = [
      IceTypes.ACCOUNT_TYPE.actFacility.toString() + ".*",
      IceTypes.ACCOUNT_TYPE.actProvider.toString() + ".*",
      IceTypes.ACCOUNT_TYPE.actPatient.toString() + ".*",
    ];

    // To do add try catch
    let msg: message = new message();
    msg.from = userInfo.Username;
    if (!Iceutility.isStringUndefinedNullOrEmpty(this.newPostMessageKey)) {
      msg.message_key = this.newPostMessageKey;
    }
    else {
      msg.message_key = Iceutility.guid(true);
    }
    msg.to = event.clickedItem ? (event.clickedItem.value + ".*") : defaultTO.join(",");
    msg.subject = panel ? "" : this.newPostTitleCtrl.getFormControl().value;
    msg.message_date = Iceutility.ConvertToUTC(Iceutility.GetLocalDate(), true);
    msg.message_body = panel ? this.getPostControlValue(panel, 'MessageBody') : this.newPostMessageCtrl.getFormControl().value;
    msg.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    msg.trans_account = this.appSvc.getCurrentAccount();
    msg.account_type = this.appSvc.getCurrentAccountType();
    msg.message_status = IceTypes.trans_status.isReadyToSend;
    msg.trans_type = IceTypes.TRANSTYPE.itDashboardPost;

    msg.subject = this.newPostSubject;
    msg.requested_access_country_id = this.newPostCountry;
    if (this.newPostAttachments.length > 0) {
      msg.ATTACHMENTS = this.newPostAttachments;
    }

    if (event.clickedItem) {
      if (event.clickedItem.name.indexOf("Blog") >= 0)
        msg.blog = true;

      msg.requested_access_account_type = event.clickedItem.value;
    }

    this.linkEditCountryCtrl.getFormControl().reset();
    this.linkEditSubjectCtrl.getFormControl().reset();

    this.messageService.sendMessage(msg, this.navSvc).subscribe(data => {
      this.newPostTitleCtrl.getFormControl().reset();
      this.newPostMessageCtrl.getFormControl().reset();
      this.newPostMessageKey = "";
      this.newPostAttachments = [];
      this.newPostAttachmentFiles = {};
      this.newPostSubject = "";
      this.newPostCountry = "";

      msg.message_date = Iceutility.GetLocalDate();
      let readMoreLinkEnabled = msg.message_body.length > maxMessageLength;
      msg["_fromUserId"] = msg.from;
      msg["_originalMessage"] = msg.message_body;
      msg["_readMoreLinkEnabled"] = readMoreLinkEnabled
      msg.message_body = msg.message_body.length > maxMessageLength ? msg.message_body.substr(0, maxMessageLength) : msg.message_body;
      let fromUser = <user>DomainService.mappedMembers[msg.from.toLowerCase()];

      if (fromUser && !Iceutility.isStringUndefinedNullOrEmpty(fromUser.external_data_key)) {
        this.domainService.loadMemberPhoto(msg.from, fromUser.external_data_key, this,
          (blob: File, dashboardComp: any) => {
            try {
              const reader = new FileReader();
              reader.addEventListener('load', (event: any) => {
                if (<string>event["currentTarget"]["result"] != null) {
                  let url = <string>event["currentTarget"]["result"];
                  url = url.replace("data:text/html;base64,", "data:image/png;base64");
                  msg["_profilePicUrl"] = url;
                }
                this.publishPost(msg, data);
              });
              reader.readAsDataURL(blob);
            }
            catch (e) {
              console.log(e);
            }
          },
          (error) => {
            this.publishPost(msg, data);
          });
      } else {
        this.publishPost(msg, data);
      }
    }, error => {
      console.log(error);
    });
  }

  getButtonSettings(text: string, iconClass: string): IcecontrolSettings {
    return new IcecontrolSettings(
      "icebutton",
      {
        text: text ? text : "",
        class: [],
        glyphClass: "fas " + (iconClass ? iconClass : "fa-blog")
      },
      null,
      null
    );
  }

  getMenuItems() {
    this.menuItems.push({ name: "Share with All Private Networks", value: IceTypes.ACCOUNT_TYPE.actFacility });
    let currentAccount = this.appSvc.getCurrentAccount();
    let currentAccountType = this.appSvc.getCurrentAccountType();
    let currentPatient = this.appSvc.getCurrentPatient();
    let promises = [];

    if (!Iceutility.isStringUndefinedNullOrEmpty(currentAccount)) {
      promises.push(this.domainService.getProvider(currentAccount));
    }
    if (!Iceutility.isStringUndefinedNullOrEmpty(currentPatient)) {
      promises.push(this.domainService.getPatient(currentPatient, ""));
    }
    this.menuItems.push({ name: "Share with All Public Network Members", value: IceTypes.ACCOUNT_TYPE.actNone });

    /// TODO: add permission check
    this.menuItems.push({ name: "Blog on Patient Networks", value: IceTypes.ACCOUNT_TYPE.actPatient });
    this.menuItems.push({ name: "Blog on Provider Networks", value: IceTypes.ACCOUNT_TYPE.actProvider });
    this.menuItems.push({ name: "Blog on Pharmacy Networks", value: IceTypes.ACCOUNT_TYPE.actPharmacy });
    this.menuItems.push({ name: "Blog on Payer Networks", value: IceTypes.ACCOUNT_TYPE.actPayer });
    this.menuItems.push({ name: "Blog on Vendor Networks", value: IceTypes.ACCOUNT_TYPE.actVendor });

    forkJoin(promises).subscribe(responseList => {
      for (let responseIndex = 0; responseIndex < responseList.length; responseIndex++) {
        if (Iceutility.isdefined(responseList[responseIndex]) && responseList[responseIndex].length > 0) {
          let entity = responseList[responseIndex][0];
          switch (entity.constructor.name) {
            case "provider":
              let pt_entity = this.domainService.getsubtreedata(entity["ENTS"], "entity_key", entity.entity_key);
              if (pt_entity != null) {
                let name = currentAccountType == IceTypes.ACCOUNT_TYPE.actProvider ? pt_entity["prefix"] + " " + pt_entity["first_name"] + " " + pt_entity["last_name"] : pt_entity["organization_name"];
                this.menuItems.push({ name: "Share with " + name + " Network", value: IceTypes.ACCOUNT_TYPE.actProvider });
              }
              break;
            case "patient":
              let name = this.appSvc.getPatientName(entity);
              this.menuItems.push({ name: "Share with " + name + "'s network", value: IceTypes.ACCOUNT_TYPE.actPatient });
              break;
          }
        }
      }
    });
  }

  onNetworkItemClick(event) {
    let key = event.currentTarget.getAttribute("data-key");
    if (key) {
      let post = <HTMLElement>document.querySelector("[data-key='" + key + "']");
      if (post) {
        post.offsetParent.classList.add("ice-background-lightgrey");
        post.scrollIntoView({ behavior: "smooth", block: "center" });

        setTimeout(function () {
          post.offsetParent.classList.remove("ice-background-lightgrey");
        }, 2000);
      }
    }
  }

  onAttachImageClick(event: any) {
    this.newPostAttachments.push(null);
    this.newPostAttachmentFiles[FileUploadClicked] = true;
  }

  onAttachImageSelect(event: any) {
      if (event && event.target.files && event.target.files[0]) {
        var reader = new FileReader();
        var fileToUpload = event.target.files[0];
        let fil: File = <File>fileToUpload;
        if (fil != null) {

          // remove status attachments
          if (this.newPostAttachmentFiles[FileUploadClicked] != null) {
            this.newPostAttachmentFiles[FileUploadClicked] = null;
            delete this.newPostAttachmentFiles[FileUploadClicked];
          }
        }
        reader.onload = (event) => {
          let usrInfo = this.loginSvc.GetSessionUserInfo();

          if (Iceutility.isStringUndefinedNullOrEmpty(this.newPostMessageKey)) {
            this.newPostMessageKey = Iceutility.guid(true);
          }

          while (this.newPostAttachments.length > 0 && this.newPostAttachments[this.newPostAttachments.length - 1] == null) {
            this.newPostAttachments.pop(); // remove residual placeholder attachtments
          }

          this.messageService.insertMessageAttachment(this.newPostMessageKey, fileToUpload, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType()).subscribe(
            data => {
              if (data == null || data.length == 0) return;

              let extData: externaldata = <externaldata>data[0];
              this.newPostAttachments.push(extData);
              this.newPostAttachmentFiles[fil.name] = fileToUpload; // Working to upload
            },
            error => {
              console.log(error);
            });
        }
        reader.readAsDataURL(event.target.files[0]); // read file as data url
      }
  }

  isMobileDevice() {
    return Iceutility.isMobileDevice();
  }

  private getMemberName(memberIds): Observable<any> {
    if (!Iceutility.isdefined(memberIds)) {
      return Observable.throw("No member names specified.");
    }

    return this.domainService.mapMembers(memberIds);
  }

  private getFormattedMessage(msg): string {
    if (Iceutility.isStringUndefinedNullOrEmpty(msg)) {
      return "";
    }

    let Rexp = /(\b(https?|ftp):\/\/([-A-Z0-9+&@#%?=~_|!:,.;]*)([-A-Z0-9+&@#%?\/=~_|!:,.;]*)[-A-Z0-9+&@#\/%=~_|])/ig;

    return msg.replace(Rexp,
      "<a href='$1' target='_blank'>$3</a>");
  }

  private getPostedTime(messageDate, override: boolean): string {
    let date = override ? messageDate : Iceutility.ConvertFromDotNetServerTime(messageDate);
    let diffInMilliSeconds = Math.abs(date - Iceutility.GetLocalDate().getTime()) / 1000;

    // calculate days
    let days = Math.floor(diffInMilliSeconds / 86400);
    diffInMilliSeconds -= days * 86400;

    // calculate hours
    let hours = Math.floor(diffInMilliSeconds / 3600) % 24;
    diffInMilliSeconds -= hours * 3600;

    // calculate minutes
    let minutes = Math.floor(diffInMilliSeconds / 60) % 60;
    diffInMilliSeconds -= minutes * 60;

    let difference = "";
    if (days > 0) {
      difference += days + ((days === 1) ? " day" : " days") + " ago";
    } else {
      if (hours > 0) {
        difference += hours + ((hours === 1) ? " hour" : " hours") + " ago";
      } else {
        if (minutes === 0) {
          difference += "Just now";
        } else {
          difference += minutes + ((minutes === 1) ? " minute" : " minutes") + " ago";
        }
      }
    }
    return difference;
  }

  private loadAttachments(msg: message) {
    if (msg == null || msg.ATTACHMENTS == null || msg.ATTACHMENTS.length == 0) return;

    for (let iatch = 0; iatch < msg.ATTACHMENTS.length; iatch++) {
      let atch = msg.ATTACHMENTS[iatch];
      if (atch == null) continue;

      this.domainService.loadMessageFileCallback(msg.message_key, atch.external_data_key, atch.parent_src_type, this,
        (blob: File, dashboardComp: any) => {
          try {
            const reader = new FileReader();
            reader.addEventListener('load', (event: any) => {
              if (<string>event["currentTarget"]["result"] != null) {
                let url = <string>event["currentTarget"]["result"];
                atch["_postImageUrl"] = url;
              }
            });

            reader.readAsDataURL(blob);
          }
          catch (e) {
            console.log(e);
          }
        },
        (error) => {
        });
    }
  }

  private loadMemberPhoto(msg, key) {
    let testfromUser = <user>DomainService.mappedMembers[msg.from.toLowerCase()];
    if (testfromUser != null
      && !Iceutility.isStringUndefinedNullOrEmpty(testfromUser.external_data_key)
      && !Iceutility.isStringUndefinedNullOrEmpty(testfromUser["_profilePicUrl"])) {
      // skip this one because we already have the profile pic.
      return;
    }

    this.domainService.loadMemberPhoto(msg.from, key, this,
      (blob: File, dashboardComp: any) => {
        try {
          const reader = new FileReader();
          reader.addEventListener('load', (event: any) => {
            if (<string>event["currentTarget"]["result"] != null) {
              let url = <string>event["currentTarget"]["result"];
              url = url.replace("data:text/html;base64,", "data:image/png;base64");
              // Update mapped member
              msg["_profilePicUrl"] = url;
              let fromUser = <user>DomainService.mappedMembers[msg.from.toLowerCase()];
              if (fromUser != null && !Iceutility.isStringUndefinedNullOrEmpty(fromUser.external_data_key)) {
                fromUser["_profilePicUrl"] = url;
              }
            }
          });

          reader.readAsDataURL(blob);
        }
        catch (e) {
          console.log(e);
        }
      },
      (error) => {
      });
  }

  private loadPost(msg: message, msgStatus: IceTypes.trans_status): IcepanelcontainerRowSettings {
    let post = this.boardPost(msg, msgStatus);
    if (post != null) {
      this.postingSettings.push(post);
      this.sortPosts();
      this.setRecentActivityTime();
    }
    return post;
  }

  private publishPost(msg, data) {
    let fromUser = <user>DomainService.mappedMembers[msg.from.toLowerCase()];
    if (!Iceutility.isStringUndefinedNullOrEmpty(fromUser)) {
      msg["_displayName"] = fromUser ? fromUser.getdisplayname() : msg.from;
      let post = this.boardPost(data == null || data.length == 0 ? <message>data[0] : msg, msg.message_status, true);
      if (post != null) {
        this.postingSettings.unshift(post);
      }
    } else {
      let post = this.boardPost(data == null || data.length == 0 ? <message>data[0] : msg, msg.message_status, true);
      if (post != null) {
        this.postingSettings.unshift(post);
      }
    }
  }

  private setRecentActivityTime() {
    let section = this.postingSettings[0].columns[0].sections.filter(s => s.tag == "PostingSection");
    if (section.length > 0) {
      let ctrls = section[0].controls.filter(c => c.id == TimeElapsed + this.postingSettings[0].columns[0].panelKey);
      if (ctrls.length > 0) {
        this.myNetworkActivityTime = "Updated " + (ctrls[0].properties != null ? ctrls[0].properties.value : "just now");
      }
    }
  }

  private sortPosts() {
    this.postingSettings.sort((a: IcepanelcontainerRowSettings, b: IcepanelcontainerRowSettings) => {
      let date1, date2;
      let section1 = a.columns[0].sections.filter(s => s.tag == "PostingSection");
      let section2 = b.columns[0].sections.filter(s => s.tag == "PostingSection");

      if (section1.length > 0) {
        let ctrls = section1[0].controls.filter(c => c.id == "OriginalDate" + a.columns[0].panelKey);
        if (ctrls.length > 0) {
          date1 = ctrls[0].properties != null ? ctrls[0].properties.value : "";
        }
      }
      if (section2.length > 0) {
        let ctrls = section2[0].controls.filter(c => c.id == "OriginalDate" + b.columns[0].panelKey);
        if (ctrls.length > 0) {
          date2 = ctrls[0].properties != null ? ctrls[0].properties.value : "";
        }
      }
      return date2 - date1;
    });
  }

  showHideActionItems(showLessButton) {
    this.showLess = showLessButton;
    this.itemsToShow = this.showLess ? this.actionItems.length : this.actionItemMax;
  }
}
